import React, { useCallback } from "react";
import MapGL, { Marker } from "@urbica/react-map-gl";
import { mapGLMapStyles } from "@src/common/constants/mapStyles";
import {
  Theme,
  useTheme,
} from "@src/common/components/ThemeProvider/ThemeProvider";
import { useCustomLocation } from "../context";
import { CustomMarker } from "./CustomMarker";

export const LocationMap: React.FC = () => {
  const {
    viewport,
    setViewport,
    markerPosition,
    setMarkerPosition,
    isDragging,
    setIsDragging,
    setHasPinned,
  } = useCustomLocation();

  const { effectiveTheme } = useTheme();
  const isDark = effectiveTheme === Theme.DARK;

  const handleDragStart = useCallback(() => {
    setIsDragging(true);
  }, [setIsDragging]);

  const handleDragEnd = useCallback(
    (location: { lng: number; lat: number }) => {
      setIsDragging(false);
      setMarkerPosition({
        longitude: location.lng,
        latitude: location.lat,
      });
      setHasPinned(true);
    },
    [setIsDragging, setMarkerPosition, setHasPinned]
  );

  return (
    <div className="col-span-2 flex flex-col rounded-lg overflow-hidden">
      <MapGL
        style={{ width: "100%", height: "100%" }}
        mapStyle={isDark ? mapGLMapStyles.dark.url : mapGLMapStyles.light.url}
        accessToken={process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN}
        onViewportChange={setViewport}
        {...viewport}
      >
        <Marker
          longitude={markerPosition.longitude}
          latitude={markerPosition.latitude}
          draggable
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
        >
          <CustomMarker dragging={isDragging} />
        </Marker>
      </MapGL>
    </div>
  );
};
